import constants_default from '^/components/global/constants';

export default {
  ...constants_default,
  // create customer default
  IS_REGISTER_DEFAULT: true,
  // show or hide the aside on the right product information of the product detail page
  IS_SHOW_PRODUCT_DETAIL_RIGHT_SIDEBAR: false,
}



// WEBPACK FOOTER //
// ./ixcms/themes/gqf/src/vue-src/components/global/constants.js